import { Wind, ShieldCheck, HeartPulse, ScrollText, Flame, Sparkles } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { useSettings } from "@/context/SettingsContext";

const TENETS = [
  {
    icon: Wind,
    title: "Speaking in Tongues",
    text: "The baptism and infilling of the Holy Ghost, with the evidence of speaking in other tongues (Acts 2:4).",
  },
  {
    icon: ShieldCheck,
    title: "Deliverance",
    text: "Freedom from every bondage and oppression through the authority of the name of Jesus Christ.",
  },
  {
    icon: HeartPulse,
    title: "Divine Healing",
    text: "We believe God still heals today — restoring the body, soul, and spirit by His power.",
  },
  {
    icon: ScrollText,
    title: "Prophecy",
    text: "The prophetic word, spoken under the unction of the Holy Ghost, to direct, correct, and encourage.",
  },
  {
    icon: Flame,
    title: "The Mantle of Elijah",
    text: "Apostle McKuhn carries the mantle and spirit of Elijah — calling a generation back to the living God.",
  },
  {
    icon: Sparkles,
    title: "Signs & Wonders",
    text: "We contend in faith for the miraculous — believing God for signs, wonders, and resurrection power.",
  },
];

export const Beliefs = () => {
  const { content } = useSettings();
  return (
  <section
    id="beliefs"
    data-testid="beliefs-section"
    className="relative py-24 sm:py-32 bg-parchment-alt dark:bg-[#0B0F19]"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl">
        <Reveal>
          <Overline>Ministry &amp; Beliefs</Overline>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-tight">
            An apostolic, Pentecostal ministry.
          </h2>
          <p className="mt-6 text-base sm:text-lg leading-relaxed text-muted-foreground">
            {content?.beliefs_intro ??
              "Charles McKuhn Ministries is an apostolic, Pentecostal ministry contending for the full power of the Gospel. We believe in the baptism of the Holy Ghost, the present-day operation of the gifts of the Spirit, and the unchanging truth that Jesus Christ is the same yesterday, today, and forever."}
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {TENETS.map((t, i) => (
          <Reveal key={t.title} delay={(i % 3) * 0.1}>
            <div className="h-full p-7 rounded-2xl bg-card border border-border hover:-translate-y-1.5 transition-transform duration-300">
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gold/10 text-gold-deep dark:text-gold-light">
                <t.icon size={22} />
              </span>
              <h3 className="mt-5 font-serif text-xl font-semibold">{t.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                {t.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-12 p-8 sm:p-10 rounded-3xl bg-ink text-parchment grain relative overflow-hidden">
          <div
            className="absolute inset-0 opacity-70"
            style={{
              background:
                "radial-gradient(circle at 85% 20%, rgba(197,160,89,0.18), transparent 45%)",
            }}
          />
          <p className="relative font-serif text-xl sm:text-2xl leading-snug italic text-parchment/90 max-w-4xl">
            As a true prophet of God for this day and age, Apostle Charles McKuhn
            ministers in faith — believing that the sick are healed, the bound
            are set free, and the dead are raised — that in all things God shall
            be glorified.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
